import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';
import { Price, PriceStatus } from '@utriper/core';
import { SelectCheckbox, TextInput } from '@utriper/core-ui';
import { Box, Button, Grid2, InputAdornment, Typography } from '@mui/material';
import { Add, Search } from '@mui/icons-material';

const PriceGroupFilters = ({ handleWizard = () => {} }) => {
    const { t, i18n } = useTranslation();
    const translate = (value) => t(`price_group_tab_id.filters.${value}`);
    const statusOptions = useMemo(
        () =>
            PriceStatus.getIds().map((status) => ({
                id: status,
                name: PriceStatus.getTranslatedName(PriceStatus.status, status, i18n.language),
            })),
        [i18n.language]
    );
    const typeOptions = useMemo(
        () =>
            Price.getIds().map((type) => ({
                id: type,
                name: Price.getTranslatedName(Price.types, type, i18n.language),
            })),
        [i18n.language]
    );
    const { onChangeSearchPriceGroup, onChangeStatusPriceGroup, onChangeTypePriceGroup, pgNameFilter, pgStatusFilter, pgTypeFilter } = usePriceGroupTab();

    return (
        <Box component="section" mt="24px">
            <Typography fontSize={20} fontWeight={600} sx={{ color: '#131313', mb: '8px' }} noWrap>
                {translate('title')}
            </Typography>
            <Grid2 container size={12} spacing={2} justifyContent="space-between" flexDirection={{ xs: 'column', md: 'row' }}>
                <Grid2 container size={{ xs: 12, md: 8 }} flexWrap="noWrap" flexDirection={{ xs: 'column', sm: 'row' }}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 8 }}>
                        <TextInput
                            input={{
                                slotProps: {
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            height: '48px',
                                        },
                                    },
                                },
                            }}
                            meta={{ error: null, touched: null }}
                            onChange={onChangeSearchPriceGroup}
                            value={pgNameFilter}
                            label={''}
                            placeholder={translate('name')}
                        />
                    </Grid2>
                    <Grid2 container size={{ xs: 12, sm: 6, md: 8 }} gap="8px" flexWrap="nowrap">
                        <SelectCheckbox sx={{ width: '100%', height: '48px' }} options={statusOptions} label={translate('status')} onChange={onChangeStatusPriceGroup} values={pgStatusFilter} />
                        <SelectCheckbox sx={{ width: '100%', height: '48px' }} options={typeOptions} label={translate('type')} onChange={onChangeTypePriceGroup} values={pgTypeFilter} />
                    </Grid2>
                </Grid2>

                {/* Add New Price Group */}
                <Grid2 container size={{ xs: 12, md: 4 }} justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
                    <Button
                        sx={{
                            backgroundColor: 'var(--color-utriper-blue)',
                            padding: '14px',
                        }}
                        variant="contained"
                        startIcon={<Add sx={{ color: '#fff', fontSize: '24px' }} />}
                        onClick={handleWizard}
                    >
                        <Typography fontWeight={700} textTransform="none">
                            {translate('add')}
                        </Typography>
                    </Button>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default PriceGroupFilters;
